import { Link } from "react-router-dom";
import SearchBar from "../../../../common-elements/search-bar/SearchBar";

interface EmailHeaderProps {
  searchWord: string;
  setSearchWord: (value: string) => void;
  setComposeEmail: (value: boolean) => void;
}

const EmailHeader: React.FC<EmailHeaderProps> = ({
  searchWord,
  setSearchWord,
  setComposeEmail,
}) => {
  return (
    <div
      className="mail-header-wrapper"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 15px",
        width: "100%",
      }}
    >
      <div
        className="mail-left"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          flex: "1",
        }}
      >
        <SearchBar
          label="Search"
          value={searchWord}
          onChange={(e) => setSearchWord(e.target.value)}
          placeholder="Search by Email"
        />
      </div>
      <div
        className="mail-right"
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Link
          className="btn btn-primary"
          to={`${process.env.PUBLIC_URL}/communication/compose-email`}
          onClick={() => setComposeEmail(true)}
          style={{
            padding: "8px 16px",
            fontSize: "14px",
          }}
        >
          {"Compose Email"}
        </Link>
      </div>
    </div>
  );
};

export default EmailHeader;
